import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { DeploySizingComponent } from './deploy-sizing.component';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import {MatDividerModule} from '@angular/material/divider';
import { CardModule } from '../../service/card/card.module';
import { CapabilityCardModule } from 'src/app/components/capability-card/capability-card.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from "@angular/material/expansion";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormModule } from 'src/app/components/dynamic-form/dynamic-form.module';
import { ErrorModule } from 'src/app/components/error/error.module';
import { QuestionnaireSummaryModule } from 'src/app/components/questionnaire-summary/questionnaire-summary.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { InitializedComponent } from './initialized/initialized.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SizingComponent } from './sizing/sizing.component';
import { ConfigureComponent } from './configure/configure.component';
import { ResourceConfigurationContentComponent } from './resource-configuration-content/resource-configuration-content.component';
import { MonacoEditorModule } from '@vality/ng-monaco-editor';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { EnvironmentSizingDocumentsModule } from 'src/app/main/environment-details/environment-sizing-documents/environment-sizing-documents.module';

@NgModule({
  declarations: [
    DeploySizingComponent,
    InitializedComponent,
    SizingComponent,
    ConfigureComponent,
    ResourceConfigurationContentComponent
  ],
  imports: [
    CommonModule,
    BreadcrumbModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    MatDialogModule,
    TranslocoModule,
    CardModule,
    CapabilityCardModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    ReactiveFormsModule,
    FormsModule,
    DynamicFormModule,
    ErrorModule,
    QuestionnaireSummaryModule,
    MatTabsModule,
    MatIconModule,
    NgxSkeletonLoaderModule,
    MonacoEditorModule,
    EnvironmentSizingDocumentsModule
  ],
  exports: [
    SizingComponent
  ]
})
export class DeploySizingComponentModule {
}